import AppLayout from "@/layouts/AppLayout";
import { Outlet, useSearchParams } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import TabLayout from "./_TabLayout";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { Path, useNavigate } from "@/router";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";

export default function PersonDetailsLayout() {
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();

  // Early return for error cases - much cleaner!
  if (shouldRenderError || pgaId === null) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  // Normal rendering - no conditional logic needed
  const renderDesktopLayout = () => (
    <>
      <PersonObjectHeading pgaId={pgaId!} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        compactOnly
        compactTitle="Person Details"
        backLink={{ to: "/people/:pgaId", params: { pgaId: pgaId! } }}
        onBackClick={() => {
          const qs = searchParams.toString();
          navigate(`/people/${pgaId}${qs ? `?${qs}` : ""}` as Path);
        }}
      />
      <PersonObjectHeading pgaId={pgaId} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
